import { Box } from '@mui/material'
import React from 'react'
import CustomText from '../CustomText/CustomText'
import { colors } from 'styles/colors';

interface Props {
  label: string;
  value: string;
}

export default function LabelValueRow({ label, value }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <CustomText
        text={label}
        fontWeight={600}
        color={colors.black}
        fontSize={15}
        sx={{ maxWidth: '80%' }}
      />

      <CustomText
        text={value}
        fontWeight={600}
        color={colors.black}
        fontSize={15}
      />
    </Box>
  )
}
